module.exports = __webpack_public_path__ + "static/media/bvlgari-jasmin-noir-big.198c2b15.png";